import { css } from "@emotion/react";
import { colorVars, RGBA } from "apps/dashboard-client/utils/colorUtils";
import { FetchDEIHubContentResponse } from "../../../../../libs/api-service/src/lib/cms";

type HubSectionTileProps = FetchDEIHubContentResponse["hub_sections"][0] & {
  onClick: () => void;
};

const s = {
  container: css({
    border: "none",
    cursor: "pointer",
    outline: "none",
    width: "100%",
    aspectRatio: 1,
    // width: "18rem",
    borderRadius: 8,
    padding: "1.6rem",
    display: "flex",
    backgroundColor: "white",
    textAlign: "start",
    position: "relative",
    overflow: "hidden",
    ":hover": {
      filter: "brightness(90%)",
    },
  }),
  text: css({
    position: "relative",
    fontWeight: "700",
    zIndex: 2,
  }),
  backgroundImage: css({
    position: "absolute",
    zIndex: 1,
    height: "100%",
    width: "100%",
    objectFit: "cover",
    top: 0,
    left: 0,
    opacity: "0.2",
  }),
};

const HubSectionTile = ({
  title,
  text_color = colorVars.textPrimary,
  background_color = "white",
  background_image,
  onClick,
}: HubSectionTileProps) => {
  return (
    <button
      css={[s.container, { backgroundColor: background_color as RGBA }]}
      onClick={onClick}
    >
      <h3 css={[s.text, { color: text_color as RGBA }]}>{title}</h3>
      {background_image && (
        <img
          alt={"Background image"}
          src={background_image.url}
          css={s.backgroundImage}
        />
      )}
    </button>
  );
};

export default HubSectionTile;
